/* app/js/src/components/channel/channel-wizard/dynamic-promo-settings/dynamic-promo-settings.component.scss */
.cursor-pointer {
  cursor: pointer;
}
input {
  height: 30px;
  border-radius: 4px;
  background-color: #ffffff;
  font-size: 12px;
  border: solid 1px #e1e6eb;
  color: #232f3a;
  outline: none;
}
input ::-webkit-input-placeholder {
  color: #c9cdd6;
}
.text {
  color: #232f3a;
}
.text .info {
  margin-top: 25px;
  font-size: 12px;
  color: #879baf;
}
input {
  width: 100%;
  padding: 0 12px 0 12px;
}
input ::-webkit-input-placeholder {
  color: #c9cdd6;
}
.table {
  width: max-content;
  margin-top: 43px;
}
.table .table-header {
  padding-top: 10px;
  padding-bottom: 10px;
}
.table .table-row {
  height: 40px;
  font-size: 14px;
}
.table .table-row.label-field {
  vertical-align: top;
  padding-top: 5px;
}
.table .extented-settings-row {
  background-color: #eef2f6;
}
.table .extented-settings-row.first {
  border-bottom-left-radius: 10px;
  height: fit-content;
  padding-top: 7px;
  padding-left: 17px;
  padding-bottom: 14px;
}
.table .extented-settings-row.last {
  border-bottom-right-radius: 10px;
}
.button {
  color: #2864ea;
  font-size: 15px;
  text-decoration: none;
}
.button:hover {
  text-decoration: underline;
}
.button.add-extended-settings {
  font-size: 10px;
}
.dropdown-title {
  text-align: left;
}
.timespot-text-input {
  width: 250px;
}
.label {
  display: block;
  color: #879baf;
  font-size: 12px;
}
.time-picker-field {
  margin-top: -4px;
  display: inline-block;
  margin-bottom: -22px;
}
.remove-button {
  display: inline-block;
}
.remove-button:hover {
  background-color: red !important;
}
.text {
  margin: 8px 0 20px 0;
}
.display-inline {
  display: inline-block !important;
}
.pl8 {
  padding-left: 8px;
}
.pr8 {
  padding-right: 8px;
}
/*# sourceMappingURL=dynamic-promo-settings.component.css.map */
